import { useEffect } from "react";
import { Theme } from "../modules/profile/types/profile";
import { useThemeFetcher } from "../modules/profile/hooks/useThemeFetcher";
import { useThemeUpdater } from "../modules/profile/hooks/useThemeUpdater";
import { useUser } from "../../shared/context/UserContext";
import { pageTitle } from "src/shared/utils/brand";

interface UseThemeReturn {
  theme: Theme | null;
  loading: boolean;
  storedColor: Theme[];
  backColor: string;
  fontColour: string;
  fontFamily: string;
  businessType: string;
  updateTheme: (newTheme: Theme) => Promise<{ success: boolean; error?: unknown }>;
}

export const useTheme = (): UseThemeReturn => {
  const { theme, loading, storedColor, setTheme, setStoredColor, fetchTheme } = useThemeFetcher();
  const { updateTheme } = useThemeUpdater(setTheme, setStoredColor);
  const { user } = useUser();
  const businessType = user?.themes.backgroundColour || "";

  useEffect(() => {
    fetchTheme();
    document.title = pageTitle("Profile");
  }, [fetchTheme]);

  return {
    theme,
    loading,
    storedColor,
    backColor: theme?.backgroundColor ?? "",
    fontColour: theme?.fontColor ?? "",
    fontFamily: theme?.fontFamily ?? "",
    businessType,
    updateTheme,
  };
};

export default useTheme;